import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AddPaymentMethodRequestBody } from '@/domains/payments/features/paymentModals/modals/AddPaymentMethod/types/AddPaymentMethodRequestBody';

export const addPaymentMethodSlice = createSlice({
  name: 'addPaymentMethodSlice',
  initialState: {},
  reducers: {
    addPaymentMethod(_state, _action: PayloadAction<AddPaymentMethodRequestBody>) {},
  },
});

export const { addPaymentMethod } = addPaymentMethodSlice.actions;

export const { reducer: addPaymentMethodReducer, reducerPath: addPaymentMethodReducerPath } = addPaymentMethodSlice;
